/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitHostingServiceResult
 */
export interface MonitHostingServiceResult {
    /**
     * 
     * @type {number}
     * @memberof MonitHostingServiceResult
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitHostingServiceResult
     */
    service?: string;
}

/**
 * Check if a given object implements the MonitHostingServiceResult interface.
 */
export function instanceOfMonitHostingServiceResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitHostingServiceResultFromJSON(json: any): MonitHostingServiceResult {
    return MonitHostingServiceResultFromJSONTyped(json, false);
}

export function MonitHostingServiceResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitHostingServiceResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'service': !exists(json, 'service') ? undefined : json['service'],
    };
}

export function MonitHostingServiceResultToJSON(value?: MonitHostingServiceResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'service': value.service,
    };
}

